import { render, staticRenderFns } from "./AddWebHostingDatabaseModal.vue?vue&type=template&id=6b5cb8da&scoped=true&"
import script from "./AddWebHostingDatabaseModal.vue?vue&type=script&lang=js&"
export * from "./AddWebHostingDatabaseModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5cb8da",
  null
  
)

export default component.exports